import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Input,
	Select,
	DatePicker,
	Button,
	message,
	Space,
	Typography,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;

const EditTransferRecordModal = ({
	visible,
	onCancel,
	onSuccess,
	transferRecord,
}) => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (visible && transferRecord) {
			form.setFieldsValue({
				transfer_type: transferRecord.transfer_type,
				transfer_date: dayjs(
					transferRecord.transfer_date
				),
				corressponding_church:
					transferRecord.corressponding_church,
				reason: transferRecord.reason,
			});
		}
	}, [visible, transferRecord, form]);

	const handleSubmit = async (values) => {
		try {
			setLoading(true);
			const submitData = {
				transfer_type: values.transfer_type,
				transfer_date:
					values.transfer_date.format(
						"YYYY-MM-DD"
					),
				corressponding_church:
					values.corressponding_church,
				reason: values.reason || "",
			};

			const response = await useAxios.put(
				`/users/update-transfer-record/${transferRecord.id}/`,
				submitData
			);

			if (response.status === 200) {
				message.success(
					"이명 기록이 성공적으로 수정되었습니다."
				);
				form.resetFields();
				if (onSuccess) {
					onSuccess();
				}
			}
		} catch (error) {
			message.error("이명 기록 수정에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleDelete = async () => {
		try {
			setLoading(true);
			const response = await useAxios.delete(
				`/users/update-transfer-record/${transferRecord.id}/`
			);

			if (response.status === 204) {
				message.success(
					"이명 기록이 성공적으로 삭제되었습니다."
				);
				if (onSuccess) {
					onSuccess();
				}
			}
		} catch (error) {
			message.error("이명 기록 삭제에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title={
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "8px",
					}}>
					<EditOutlined />
					<span>이명 기록 수정</span>
				</div>
			}
			open={visible}
			onCancel={handleCancel}
			footer={null}
			width={600}>
			{transferRecord && (
				<div style={{ marginBottom: 16 }}>
					<Text type="secondary">
						성도: {transferRecord.user_name}
					</Text>
				</div>
			)}

			<Form
				form={form}
				layout="vertical"
				onFinish={handleSubmit}>
				<Form.Item
					label="이명 유형"
					name="transfer_type"
					rules={[
						{
							required: true,
							message: "이명 유형을 선택하세요",
						},
					]}>
					<Select placeholder="이명 유형 선택">
						<Option value="전입">
							<span
								style={{
									color: "green",
								}}>
								전입
							</span>
						</Option>
						<Option value="전출">
							<span
								style={{
									color: "red",
								}}>
								전출
							</span>
						</Option>
					</Select>
				</Form.Item>

				<Form.Item
					label="이명일"
					name="transfer_date"
					rules={[
						{
							required: true,
							message: "이명일을 선택하세요",
						},
					]}>
					<DatePicker
						inputReadOnly={isMobile}
						style={{
							width: "100%",
						}}
						format="YYYY-MM-DD"
					/>
				</Form.Item>

				<Form.Item
					label="상대교회"
					name="corressponding_church"
					rules={[
						{
							required: true,
							message: "상대교회를 입력하세요",
						},
					]}>
					<Input placeholder="상대교회 입력" />
				</Form.Item>

				<Form.Item
					label="이명사유"
					name="reason"
					rules={[
						{
							required: true,
							message: "이명사유를 입력하세요",
						},
					]}>
					<TextArea
						rows={4}
						placeholder="이명사유를 상세히 입력하세요"
					/>
				</Form.Item>

				<Form.Item>
					<Space>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							icon={<EditOutlined />}>
							수정
						</Button>
						<Button
							danger
							onClick={handleDelete}
							loading={loading}>
							삭제
						</Button>
						<Button onClick={handleCancel}>
							취소
						</Button>
					</Space>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditTransferRecordModal;
